import Service from '@/helpers/service'

export default {

    index(params) {
        return Service().get('item-category/index', {params});
    },
    getMaterialCategoryPR(params) {
        return Service().get('item-category/get-item-category', {params});
    },
    show(id) {
        return Service().get('item-category/show/'+id);
    },
    create(params) {
        return Service().post('item-category/create', params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    update(id, params) {
        return Service().post('item-category/update/'+id, params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    delete(id) {
        return Service().post('item-category/delete/'+id);
    },
}